import { POLL_TYPES } from './constants';

const POLL_PART_PREFIXES = {
    [POLL_TYPES.POLL]: 'voting-poll',
    [POLL_TYPES.H2H]: 'h2h-poll',
    [POLL_TYPES.TRIVIA]: 'multi-choice-trivia',
    [POLL_TYPES.FREE_TEXT]: 'free-text-trivia',
    [POLL_TYPES.TOP_THREE]: 'top-three-poll'
};

export const getPollTypePartPrefix = (pollType) => {
    return POLL_PART_PREFIXES[pollType] || 'poll';
};

export const joinParts = (...parts) => {
    return parts.filter(Boolean).join(' ');
};
